import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnChanges {
  @Input() active: boolean = false;
  @Input() control?: FormControl;
  @Output() activeChange = new EventEmitter<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control']?.currentValue) {
      const currentActiveValue = !!changes['control'].currentValue.value;
      if (currentActiveValue !== this.active) {
        this.active = currentActiveValue;
      }
    }
  }

  toggle(): void {
    this.active = !this.active;
    this.activeChange.emit(this.active);
    if (this.control) {
      this.control.patchValue(this.active);
      this.control.markAsDirty();
      this.control.markAsTouched();
    }
  }
}
